exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".game-stage {\n  width: 100%;\n  height: 100%;\n  background-position: center center;\n  background-size: cover;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  overflow: hidden; }\n", ""]);

